import { IonRouterLink } from '@ionic/react';
import { User, isSubscriber } from 'model';
import React from 'react';
import { colorFromCreated } from '../util/colorFromId';
import { getInitials } from '../util/initials';
import { ProfileImage, ProfileImageSize } from './ProfileImage';
import { IconSize } from './QuirkIcons/QuirkIcon.js';
import { IconCheckCircle } from './QuirkIcons/index.js';
interface profilePicType {
	user?: User;
	size?: ProfileImageSize;
	selectedImage?: any;
	disableClick?: boolean;
	testId?: string;
}

/**
 * Get an appropriate size for the status icon based on the profile pic size
 * @param { ProfileImageSize | undefined } size size prop for the ProfilePic
 * @returns { IconSize } the IconSize for the status icon
 */
function getIconSize(size?: ProfileImageSize): IconSize {
	switch (size) {
		case 'tiny':
		case 'large':
		case 'medium':
		case 'small':
			return size;
		case 'xsmall':
		case 'avatar':
			return 'tiny';
		default:
			return 'small';
	}
}

export const ProfilePic: React.FC<profilePicType> = ({ user, size = 'medium', disableClick, testId }) => {
	const url =
		user !== undefined && user.profileImage !== ''
			? `/api/users/profileImage/${user._id}/${user.profileImage}`
			: undefined;
	const component = (
		<ProfileImage
			size={size}
			testId={testId}
			url={url}
			text={user !== undefined ? getInitials(user.username) : undefined}
			background={user ? colorFromCreated(user.created) : 'inherit'}
			fallback={<>{user !== undefined && getInitials(user.username)}</>}
			statusIcon={user && isSubscriber(user) ? <IconCheckCircle size={getIconSize(size)} /> : undefined}
		/>
	);

	return disableClick ? (
		component
	) : (
		<IonRouterLink routerLink={`/main/settings/userprofile/${user?._id}`}>{component}</IonRouterLink>
	);
};
